/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Box, Theme, useTheme } from '@mui/material'
import React from 'react'
import { QuickLink } from './QuickLink'

interface QuickLinkData {
  label: string
  onClick?: () => void
}

interface QuickLinksProps {
  links: QuickLinkData[]
  theme: Theme
}

export const QuickLinks: React.FC<QuickLinksProps> = ({ links }) => {
  const theme = useTheme()
  return (
    <Box css={() => quickLinksContainer({ theme })}>
      {links.map((link, index) => (
        <QuickLink key={index} label={link.label} onClick={link.onClick} theme={theme} />
      ))}
    </Box>
  )
}

export const quickLinksContainer = ({ theme }: { theme: Theme }) => css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px 44px;
  justify-items: center;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  ${theme.breakpoints.down('md')} {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  ${theme.breakpoints.down('sm')} {
    gap: 16px;
  }
`
